
<div class="text-area" [ngStyle]="applyDesign()">
  <input 
    type="text" 
    class="input-text" 
    [placeholder]="placeholder" 
    [disabled]="disabled" 
    [(ngModel)]="text" 
    [value]="initValue"
    (input)="getChanges($event)"
    style="flex: 1"
    >
<img *ngIf="searchField" src="assets/icons/Icon ionic-ios-search.svg">
</div>
